import React, { FormEvent } from 'react';
import { NavLink } from 'react-router-dom';
import InputWithButton from '../Common/InputWithButton/InputWithButton';

interface Props {
    onSubmitCode: (e: FormEvent<HTMLFormElement>) => void;
    onChange: (e: Event) => void;
    isFormValid: boolean;
    twoFactorAuthCode: string;
}

const TfaSignInForm: React.FC<Props> = ({ onSubmitCode, onChange, isFormValid, twoFactorAuthCode }) => {
    const valid = (!isFormValid) ? "was-validated" : "";
    const formClass = "form-signin " + valid;

    return (
        <form name="tfa-signin-form" onSubmit={onSubmitCode} className={formClass} noValidate>
            <div>
                <div>
                    <h2>Two-Factor Authentication</h2>

                    <div className="form-group">
                        <p id="tfaHelp" className="form-text">Enter an authenticator app code or a recovery code:</p>
                        <InputWithButton
                            name="twoFactorAuthCode"
                            type="text"
                            value={twoFactorAuthCode}
                            onChange={onChange}
                            errorMessage="Please enter a code"
                            isFocused={true}
                            isRequired={true}
                            showButton={true}
                            onButtonClick={onSubmitCode} />
                    </div>
                </div>
            </div>

            {!isFormValid &&
                <div className="forgot-things">
                    <div>
                        Having trouble with Two Factor Authentication? Contact your company administrator or <a href="mailto:support@getpacer.com">support@getpacer.com</a>
                        {/* Lost all 2FA devices and backup codes? <NavLink className="nav-link" to="/some-future-link">Try recovery</NavLink> */}
                    </div>
                </div>
            }
        </form>
    );
};

export default TfaSignInForm;
